/* Build Your Own Bundle
   Logic lives here so the section file does not have to be re-uploaded for JS changes.
   Config arrives as JSON in [data-byob-config] inside the section. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.byobReady === 'true') return;
    var cfgEl = root.querySelector('[data-byob-config]');
    if (!cfgEl) return;

    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.dataset.byobReady = 'true';

    var picked = [];

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      return String(CFG.moneyFormat || '${{amount}}')
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
    }

    function currentTier() {
      var best = null;
      CFG.tiers.forEach(function (t) {
        if (picked.length >= t.qty && (!best || t.pct > best.pct)) best = t;
      });
      return best;
    }

    function render() {
      var slotsEl = root.querySelector('[data-byob-slots]');
      var html = '';
      for (var i = 0; i < CFG.slots; i++) {
        var item = picked[i];
        var unlock = '';
        CFG.tiers.forEach(function (t) {
          if (t.qty === i + 1) unlock = '<span class="byob__unlock">Unlock ' + t.pct + '%</span>';
        });
        if (item) {
          html += '<div class="byob__slot">' +
                    '<span class="byob__slotbox"><img src="' + item.image + '" alt=""></span>' +
                    '<span class="byob__slotlabel">' + item.title + unlock + '</span>' +
                    '<button type="button" class="byob__remove" data-byob-remove="' + i + '" aria-label="Remove">&times;</button>' +
                  '</div>';
        } else {
          html += '<div class="byob__slot">' +
                    '<span class="byob__slotbox"></span>' +
                    '<span class="byob__slotlabel">Select a product' + unlock + '</span>' +
                  '</div>';
        }
      }
      slotsEl.innerHTML = html;

      var subtotal = picked.reduce(function (s, i) { return s + i.price; }, 0);
      var tier = currentTier();
      var save = tier ? Math.round(subtotal * tier.pct / 100) : 0;

      root.querySelector('[data-byob-subtotal]').textContent = money(subtotal);
      var saveRow = root.querySelector('[data-byob-saverow]');
      var saveEl = root.querySelector('[data-byob-save]');
      saveEl.textContent = save > 0 ? money(save) : '';
      saveRow.hidden = save <= 0;

      var t1 = CFG.tiers[0], t2 = CFG.tiers[1];
      var tier1El = root.querySelector('[data-byob-tier="1"]');
      var tier2El = root.querySelector('[data-byob-tier="2"]');
      var remaining = t1.qty - picked.length;
      tier1El.textContent = remaining > 0
        ? remaining + ' more for ' + t1.pct + '% off'
        : t1.pct + '% unlocked';
      tier1El.setAttribute('data-met', picked.length >= t1.qty ? 'true' : 'false');
      tier2El.setAttribute('data-met', picked.length >= t2.qty ? 'true' : 'false');

      var cta = root.querySelector('[data-byob-cta]');
      cta.disabled = picked.length === 0;
      cta.textContent = CFG.buttonLabel + '  ' + money(subtotal - save);

      root.querySelectorAll('[data-byob-add]').forEach(function (btn) {
        var on = picked.some(function (p) { return String(p.id) === btn.dataset.variantId; });
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* FoxTheme's cart-drawer.js subscribes to ON_ITEM_ADDED. Emitting it refreshes the
       drawer and, when the drawer has data-open-when-added="true", opens it.
       Nothing else in this theme reacts to a cart change, which is why a reload was
       previously the only way to see new items. */
    function notifyTheme(state) {
      try {
        if (window.FoxThemeEvents && typeof window.FoxThemeEvents.emit === 'function') {
          window.FoxThemeEvents.emit('ON_ITEM_ADDED', state);
          return true;
        }
      } catch (e) {}
      return false;
    }

    function addBundle(cta) {
      cta.disabled = true;
      var counts = {};
      picked.forEach(function (p) { counts[p.id] = (counts[p.id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) {
        return { id: Number(id), quantity: counts[id] };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'cart'); });
          return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          var notified = notifyTheme(state);

          if (CFG.afterAdd === 'cart' && !CFG.designMode) {
            var tier = currentTier();
            window.location.href = (tier && tier.code)
              ? '/discount/' + encodeURIComponent(tier.code) + '?redirect=/cart'
              : '/cart';
            return;
          }

          cta.textContent = 'Added. Cart now holds ' + state.item_count +
                            (state.item_count === 1 ? ' item' : ' items');
          if (!notified) cta.textContent += ' (open the cart to view)';
          window.setTimeout(function () { render(); }, 3000);
        })
        .catch(function (err) {
          cta.disabled = false;
          render();
          window.alert('Could not add your bundle: ' + (err && err.message ? err.message : 'unknown error'));
        });
    }

    root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-byob-add]');
      if (add) {
        if (picked.length >= CFG.slots) return;
        picked.push({
          id: add.dataset.variantId,
          title: add.dataset.title,
          price: parseInt(add.dataset.price, 10),
          image: add.dataset.image
        });
        render();
        return;
      }
      var rm = e.target.closest('[data-byob-remove]');
      if (rm) {
        picked.splice(parseInt(rm.dataset.byobRemove, 10), 1);
        render();
        return;
      }
      var cta = e.target.closest('[data-byob-cta]');
      if (cta && !cta.disabled) addBundle(cta);
    });

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-byob-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* The theme editor re-renders a section on every settings change, which destroys and
     rebuilds the DOM. Without this the builder goes dead after the first edit. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
